import { Component, Input } from '@angular/core';
import { GenericListItemDisabled } from '../model/list';

@Component({
  selector: 'app-generic-list-item-disabled',
  templateUrl: './generic-list-item-disabled.component.html',
  styleUrl: './generic-list-item-disabled.component.css'
})
export class GenericListItemDisabledComponent {

    @Input() data: GenericListItemDisabled
    withoutSub: boolean = true
    constructor() { }

    ngOnInit(): void {
      if (this.data.subTitle) this.withoutSub = false
    }

    click() {
      this.data.onClick()
    }

    delete() {
      this.data.onDelete()
    }

}
